const reducer = (state, action) => {
  switch (action.type) {
    case "setShowingBioModal":
      return {
        ...state,
        showingBioModal: action.showingBioModal,
      };
    case "setBioModalContent":
      return {
        ...state,
        bioModalContent: action.bioModalContent,
        showingBioForm: !action.bioModalContent,
      };
    case "setShowingBioForm":
      return {
        ...state,
        showingBioForm: action.showingBioForm,
      };

    default:
      return state;
  }
};

const initialState = {
  showingBioModal: false,
  showingBioForm: false,
  bioModalContent: null,
};

export default {
  reducer,
  initialState,
};
